<template>
<div>
  <default-list-item :item="item" />
  <ul>
    <li v-for="(child, i) in item.children" :key="`menu-${i}`">
      <label v-if="child.heading">{{child.heading}}</label>
      <default-list-group
        v-else-if="child.children && child.children"
        :item="child"/>
      <default-list-item v-else :item="child" />
    </li>
  </ul>
</div>
</template>

<script>
import DefaultListItem from './ListItem'
export default {
  name: 'DefaultListGroup',
  components: {
    DefaultListItem
  },
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    model: function (va1, val2) {
      console.log(va1, val2)
    }
  },
  data: () => ({ model: null }),
  computed: {
    group () {
      return this.genGroup(this.item.children)
    },
    icon () {
      if (!this.item.icon) return undefined
      const [off, on] = this.item.icon.split(':')
      return this.model ? (on || off) : off
    }
  },
  methods: {
    genGroup (items) {
      return items.reduce((acc, cur) => {
        acc.push(
          cur.children
            ? this.genGroup(cur.children)
            : cur.to
        )
        return acc
      }, []).join('|')
    }
  }
}
</script>
